import client from "./client";

export default {

    async getArrearsAndDelayedPayments(filters) {
        return client.parseResponse(await client.get('/tenancy-arrears', filters));
    },

    async getAlltenancy(filters) {
        return client.parseResponse(await client.get('/tenancy', filters));
    },
    async gettenancy(id) {
        return client.parseResponse(await client.get('/tenancy/' + id));
    },
    async gettenancyDetails(filters) {
        return client.parseResponse(await client.get('/tenancy-details', filters));
    },
    async createtenancy(data) {
        return client.parseResponse(await client.post('/tenancy', data))
    },
    async edittenancy(data) {
        return client.parseResponse(await client.put('/tenancy/' + data.id, data))
    },
    async deletetenancy(data) {
        return client.parseResponse(await client.delete('/tenancy/' + data.id, data))
    },
    async downloadTenancyReport(tenancyId) {
        return client.parseResponse(await client.get('/export-tenancy-report/' + tenancyId, {}, {responseType: 'blob'}))
    },
    async sendTenancyReport(tenancyId) {
        return client.parseResponse(await client.post('/send-tenancy-report/' + tenancyId))
    }
}
